import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactSelect from 'react-select';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import shortid from 'shortid';
import { getPicklist } from '../actions';

class OtherHouseHoldMember02 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
        if (!this.props.form.Monthly_Gross_Income__c) {
            this.props.onInputChanged('0', 'Monthly_Gross_Income__c', this.props.index);
        }
    }

    shouldComponentUpdate() {
        return true;
    }

    render() {
        const {
            form, errorMessage, onInputChanged, index,
            objectInfo, mainApplicant, onFileUploaded,
            onRemoveFile, attachment,
        } = this.props;
        return (
            <div className="row">
                <div className="row">
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Relationship to Beneficiary <small className="red">(required)</small></label>
                            <select
                                onChange={onInputChanged}
                                name={`Relationship_to_Beneficiary__c.${index}`}
                                className={`form-control ${errorMessage.Relationship_to_Beneficiary__c ? 'need-fix' : ''}`}
                                placeholder="Relationship to Beneficiary"
                                value={form.Relationship_to_Beneficiary__c}
                            >
                                <option value="" />
                                {getPicklist('Relationship_to_Beneficiary__c', objectInfo.Person__c)}
                            </select>
                            <p className="error-message">{errorMessage.Relationship_to_Beneficiary__c}</p>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Other Relationship</label>
                            <input
                                onChange={onInputChanged}
                                name={`Other_Relationship__c.${index}`}
                                type="text"
                                className={`form-control ${errorMessage.Other_Relationship__c ? 'need-fix' : ''}`}
                                placeholder="Other Relationship"
                                value={form.Other_Relationship__c}
                                disabled={form.Relationship_to_Beneficiary__c !== 'Others'}
                            />
                            <p className="error-message">{errorMessage.Other_Relationship__c}</p>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Monthly Gross Income  <small className="red">(required)</small></label>
                            <input
                                onChange={onInputChanged}
                                name={`Monthly_Gross_Income__c.${index}`}
                                type="number"
                                className={`form-control ${errorMessage.Monthly_Gross_Income__c ? 'need-fix' : ''}`}
                                placeholder="0"
                                value={form.Monthly_Gross_Income__c}
                                maxLength={4}
                            />
                            <p className="error-message">{errorMessage.Monthly_Gross_Income__c}</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-4" style={{ display: mainApplicant ? 'block' : 'none' }}>
                        <div className="form-group">
                            <label>Other Source Of Income Amount</label>
                            <input
                                onChange={onInputChanged}
                                name={`Other_Source_of_Income_Amount__c.${index}`}
                                type="number"
                                className={`form-control ${errorMessage.Other_Source_of_Income_Amount__c ? 'need-fix' : ''}`}
                                placeholder="Other Source Of Income Amount"
                                value={form.Other_Source_of_Income_Amount__c}
                                disabled={form.Other_Source_of_Income__c === 'None'}
                                maxLength={4}
                            />
                            <p className="error-message">{errorMessage.Other_Source_of_Income_Amount__c}</p>
                        </div>
                    </div>
                    <div className="col-sm-4" style={{ display: mainApplicant ? 'block' : 'none' }}>
                        <div className="form-group">
                            <label>Remarks</label>
                            <input
                                onChange={onInputChanged}
                                name={`Remarks__c.${index}`}
                                className={`form-control ${errorMessage.Remarks__c ? 'need-fix' : ''}`}
                                placeholder="Remarks"
                                value={form.Remarks__c}
                            />
                            <p className="error-message">{errorMessage.Remarks__c}</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Upload NRIC/Birth Cert File</label><br />
                            <label className="fileContainer">
                                Choose File
                                <input
                                    onChange={onFileUploaded}
                                    onClick={(e) => { e.target.value = null; }}
                                    type="file"
                                    name={`NricFin.${index}`}
                                    className="form-control-file"
                                    aria-describedby="fh1"
                                    accept=".jpeg,.jpg,.png,.pdf,image/jpeg,image/pjpeg,image/png,application/pdf"
                                />
                            </label>
                            <br />
                            <p className="text">{attachment.NricFin ? attachment.NricFin.Name : null}</p>
                            {attachment.NricFin ? (
                                <a href={null} onClick={() => onRemoveFile('NricFin', index)} className="btn btn-xs">
                                    <i className="fa fa-times" />
                                </a>
                            ) : null}
                            <br />
                            <label>
                                <small id="fileHelp1" className="form-text text-muted">format: jpg, png, pdf only </small>
                            </label>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Upload Past 3 Months CPF Statement</label><br />
                            <label className="fileContainer">
                                Choose File
                                <input
                                    onChange={onFileUploaded}
                                    onClick={(e) => { e.target.value = null; }}
                                    type="file"
                                    name={`CPMF.${index}`}
                                    className="form-control-file"
                                    aria-describedby="fh1"
                                    accept=".jpeg,.jpg,.png,.pdf,image/jpeg,image/pjpeg,image/png,application/pdf"
                                />
                            </label>
                            <p className="text">{attachment.CPMF ? attachment.CPMF.Name : null}</p>
                            {attachment.CPMF ? (
                                <a href={null} onClick={() => onRemoveFile('CPMF', index)} className="btn btn-xs">
                                    <i className="fa fa-times" />
                                </a>
                            ) : null}
                            <br />
                            <label>
                                <small id="fileHelp1" className="form-text text-muted">format: jpg, png, pdf only </small>
                            </label>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Upload latest payslip</label><br />
                            <label className="fileContainer">
                                Choose File
                                <input
                                    onChange={onFileUploaded}
                                    onClick={(e) => { e.target.value = null; }}
                                    type="file"
                                    name={`Payslip.${index}`}
                                    className="form-control-file"
                                    aria-describedby="fh1"
                                    accept=".jpeg,.jpg,.png,.pdf,image/jpeg,image/pjpeg,image/png,application/pdf"
                                />
                            </label>
                            <p className="text">{attachment.Payslip ? attachment.Payslip.Name : null}</p>
                            <br />
                            <div className="text-center">
                                {attachment.Payslip ? (
                                    <a href={null} onClick={() => onRemoveFile('Payslip', index)} className="btn btn-xs">
                                        <i className="fa fa-times" />
                                    </a>
                                ) : null}
                                <br />
                            </div>
                            <label>
                                <small id="fileHelp1" className="form-text text-muted">format: jpg, png, pdf only </small>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

OtherHouseHoldMember02.propTypes = {
    form: PropTypes.object.isRequired,
    mainApplicant: PropTypes.bool,
    onInputChanged: PropTypes.func.isRequired,
    errorMessage: PropTypes.object.isRequired,
    objectInfo: PropTypes.object.isRequired,
    index: PropTypes.number,
    onFileUploaded: PropTypes.func.isRequired,
    onRemoveFile: PropTypes.func.isRequired,
    attachment: PropTypes.object.isRequired,
};

OtherHouseHoldMember02.defaultProps = {
    index: 0,
    mainApplicant: false,
};
const mapDispatchToProps = dispatch => (
    bindActionCreators({}, dispatch)
);

const mapStateToProps = state => ({
    schoolList: state.salesforce.schoolList.fields,
});


export default connect(mapStateToProps, mapDispatchToProps)(OtherHouseHoldMember02);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Registration/Tab4/OtherHouseHoldMember02.js
// module id = 1018
// module chunks = 0